import React from 'react';
import { Box, Typography } from 'vindi-ds-components';
import toBrl from '@utils/format_currency';

const Total = ({ value }) => (
  <Box padding='2em 0 1em 0'>
    <Typography variant='body2' component='h3'>
      Total a ser cobrado
    </Typography>
    { toBrl(value) }
  </Box>
);

export default Total;
